import { ErrorBoundary } from '@sentry/react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ErrorMsg } from '../../../components/AppMessages';
import { InAppMultiSelectFilter } from '../../../components/Filters/common/InAppMultiselectFilter';
import { ALL_OPTION_NO_SPACE } from '../../../constants';
import { closeFilterOptions } from '../../../components/Filters/subs/helpers';
import { setSpecificParameter } from '../../../actions';
import { getFunnelList } from '../../../api/geoReportingApi';
import { ToggleSwitch } from '../../../components/Toogle';

interface Props {
    toggleValue: boolean;
    setToggleValue: React.Dispatch<React.SetStateAction<boolean>>;
}

const PromptFilters = withRouter((props: RouteComponentProps & Props) => {

    const { history, toggleValue, setToggleValue } = props;
    const dispatch = useDispatch();


    const searchWithoutDomain = React.useMemo(() => {
        const params = new URLSearchParams(history.location.search);
        params.delete("domain");
        params.delete("funnel")
        return params.toString();
    }, [history.location.search]);

    const { data, isFetching, refetch } = useQuery({
        queryKey: ["promptFilters", searchWithoutDomain],
        queryFn: () => getFunnelList(),
        enabled: false,
    });

    React.useEffect(() => {
        refetch();
    }, [searchWithoutDomain]);

    const funnelParam = "funnel_param";
    const [funnelFilterValue, setFunnelFilterValue] = useState(ALL_OPTION_NO_SPACE);

    const handleFunnelMultiselectSubmit = useCallback(() => {
        const parameterName = funnelParam;
        const selectedCheckboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll(
            `[type="checkbox"][data-filter-name="${parameterName}"][data-options-type="single"]:checked`
        );
        const selectedValues: Array<string> = [];
        selectedCheckboxes?.forEach((checkbox) => selectedValues.push(checkbox.value));

        const filterValue = data?.length === selectedValues?.length ? "All" : selectedValues?.join(",");
        closeFilterOptions();
        setFunnelFilterValue(filterValue);
        dispatch(setSpecificParameter(parameterName, filterValue));
    }, [data, dispatch]);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);

        params.set("funnel", funnelFilterValue);

        history.push({ search: `?${params.toString()}` });
    }, [funnelFilterValue]);

    return (
        <div>
            <div className="row grid">
                <div className=" h-30 grid-col-span-6 verbatimTile">
                    <div className="space-between verbatim-tile-header">

                        <div className="flex-row">
                            <ErrorBoundary fallback={<ErrorMsg />}>
                                <InAppMultiSelectFilter
                                    filterLabel="Funnel"
                                    optionsList={data ?? []}
                                    filterValue={funnelFilterValue}
                                    parameterName={funnelParam}
                                    parameterValue={funnelFilterValue}
                                    handleFilterSubmission={handleFunnelMultiselectSubmit}
                                />
                            </ErrorBoundary>
                            <ToggleSwitch
                                activeToggleLabel={"English"}
                                inactiveToggleLabel={"Native"}
                                active={toggleValue}
                                handleToggleClick={() => setToggleValue((prev) => !prev)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
});

export default PromptFilters;